<!-- 招聘信息列表 -->
<template>
    <div v-loading="loading" :style="{'min-height':minHeight}" style="background-color: rgba(0,0,0,0.05);width:100%;display: flex;flex-direction: column;align-items: center;justify-content: flex-start;">
        <div style="color:#333333;font-size: 15px;width:900px;box-sizing: border-box;margin: 20px 0 20px 0;display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div style="padding: 20px 20px;background-color: #fff;display: flex;flex-direction: column;align-items: center;justify-content: center;width:100%;">
                <div style="width:100%;height:30px;line-height: 30px;text-align: left;">岗位筛选</div>               
                <div style="width:100%;height:35px;margin-top:10px; display: flex; align-items: center;justify-content: space-between;">
                    <el-cascader  
                        v-model="mainListSelectValue"                   
                        placeholder="请选择招聘部门"
                        style="width:400px"
                        :options="mainList"
                        :props="{ checkStrictly: true }"                     
                        clearable>
                    </el-cascader>
                    <el-select v-model="majorListSelectValue" style="width:200px" clearable placeholder="请选择岗位类别">
                        <el-option
                        v-for="item in majorList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input  placeholder="请输入岗位名称" style="width:200px;" v-model="keywords"  clearable>
                    </el-input>
                    <el-button @click="search" type="primary" style="padding: 10px 10px;background-color:#c40001;border-color: #c40001;" icon="el-icon-search">搜索</el-button>
                </div>
                <!-- <div style="margin-top:20px;height:35px;width:100%; display: flex; align-items: center;justify-content: space-between;">
                    <el-select v-model="value" style="width:48%;" clearable placeholder="选择岗位类别">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input  placeholder="输入职位名称" style="width:48%;"  v-model="input"  clearable>
                    </el-input>
                </div> -->
            </div>
            <div style="margin-top:20px;padding: 0px 20px;background-color: #fff;display: flex;flex-direction: column;align-items: center;justify-content: center;width:100%;">
                <el-empty v-if="jobPublishList.length==0" description="还未发布任何岗位"></el-empty>

                <!-- <div v-else v-for="item in jobPublishList" :key="item.id" style="position: relative;width:100%;height:155px;margin-top:20px;border-bottom: 1px solid #eee;display: flex;flex-direction: column;align-items: flex-start;justify-content: center;">
                    <div style="width:100%;height:50px;line-height: 50px;position: relative;">
                        <span style="padding:5px 10px;background-color: #ff6b6b;color:#fff;font-size: 12px;">{{item.levelName}}</span>
                        <span style="padding:5px 10px;color:#333333;font-size: 16px;">{{ item.jobTitle }}</span>
                        <div @click="goJobEdit(item.id)" style="cursor: pointer;position:absolute;right:10px;bottom:10px;width:80px;height: 30px;line-height: 30px;text-align: center;background-color: #2d8cf0;color:#fff;font-size:12px;font-weight: 500;border-radius: 5px;">
                            岗位申请
                        </div>
                    </div>
                    <div style="font-size:14px;color:#333333;height:30px;line-height: 30px;width:100%;">
                        {{item.deptTypeName}}》{{item.parentDeptName}}》{{item.deptName}}
                    </div>
                    <div style="font-size:14px;color:#a2a4a8;height:30px;line-height: 30px;width:100%;">
                        {{item.majorName}} | {{item.typeName}} | {{item.needNumber}}人
                    </div>
                    <div style="font-size:12px;color:#444444;height:45px;width:100%;line-height: 45px;display:flex;justify-content:space-between;align-items: center;">
                        <div>{{item.address}}</div>
                        <div>发布时间：{{item.createTime.substring(0,10)}}</div>
                    </div>

                </div> -->
                <div v-else v-for="item in jobPublishList" :key="item.id" style="width:100%;margin-top:20px;border-bottom: 1px solid #eee;display: flex;flex-direction: column;align-items: flex-start;justify-content: center;border-bottom:1px solid #eeeeee;">
                    <div  style="position: relative;;width:100%;display: flex;flex-direction: column;align-items: flex-start;justify-content: center;">
                        <div style="width:100%;height:50px;line-height: 40px;">
                            <span style="padding:5px 10px;color:#2e2e2e;font-size: 18px;font-weight: bold;">{{item.childDeptName}}</span>
                        </div>
                        <div style="font-size:14px;color:#89909e;height:30px;line-height: 30px;width:100%;">
                               部门：{{item.deptTypeName}}》{{item.deptName}}
                        </div>
                        <div style="font-size:14px;color:#89909e;height:30px;line-height: 30px;width:100%;">
                               岗位类别：{{item.majorName}}
                        </div>

                        <div style="font-size:14px;color:#89909e;height:30px;line-height: 35px;width:100%;">
                            招聘人数：{{item.needNumber}}
                        </div>

                        <div style="font-size:14px;color:#89909e;height:30px;width:100%;line-height: 30px;">
                            年龄上限：{{item.ageLimit}}
                        </div>

                        <div style="font-size:14px;color:#89909e;height:30px;width:100%;line-height: 30px;">
                            学位学历：{{item.education}}
                        </div>

                        <div style="font-size:14px;color:#89909e;height:30px;width:100%;line-height: 30px;">
                            政治面貌：{{item.police}}
                        </div>
                        <div style="display:flex;justify-content: space-between;width:100%;">
                            <div style="font-size:14px;color:#89909e;height:30px;line-height: 30px;">
                                报名开始日期：{{item.startDate}}
                            </div>
                            <div style="font-size:14px;color:#89909e;height:30px;line-height: 30px;">
                                报名截止日期：{{item.endDate}}
                            </div>
                        </div>
                      
                        <div @click="goJobEdit(item.id)" style="cursor: pointer;position:absolute;right:30px;top:10px;padding:8px 20px;background-color: #c40001;color:#fff;font-size:14px;font-weight: 500;border-radius: 5px;">
                            岗位申请
                        </div>                
                    </div>  
                    <div style="width:100%;margin:10px 0 30px 0;">
                        <div style="width:100%;display: flex;align-items: center;">
                            <p style="font-size:16px;width:100px;font-weight: 500;">岗位条件描述</p>
                            <p style="width:calc(100% - 100px);height:1px;background-color: #eeeeee;"></p>
                        </div>
                        <div style="font-size:14px;color:#292c32;margin-bottom: 10px;font-weight: bold;">岗位专业：</div>
                        <div v-html="item.profession" style="width:100%;line-height: 18px;font-size:14px;font-weight: 400;;">
                        </div>
                        <div style="font-size:14px;color:#292c32;margin: 10px 0;font-weight: bold;">具体条件：</div>
                        <div v-html="item.appointCondition" style="width:100%;line-height: 18px;font-size:14px;font-weight: 400;;">
                        </div>
                        <div style="font-size:14px;color:#292c32;margin: 10px 0;font-weight: bold;">其他条件：</div>    
                        <div v-html="item.otherCondition" style="width:100%;line-height: 18px;font-size:14px;font-weight: 400;;">
                        </div>
                        <div style="font-size:13px;color:#ff0000;margin: 10px 0;font-weight: bold;">注意：请认真阅读岗位应聘须知，如实完善个人简历信息，谨慎申请岗位。一人只能申请一个岗位。</div>    
                    </div>          
                    <!-- <div @click="goJobEdit(item.id)" style="cursor: pointer;margin-top:20px;width:100%;height:60px;display: flex;align-items: center;justify-content: center;border-top:1px solid #eeeeee;">
                        <div style="padding:8px 20px;background-color: #2d8cf0;color:#fff;font-size:14px;font-weight: 500;">职位申请</div>
                    </div> -->

                
                </div>
            </div>

        </div>


        <div v-if="dialogVisible">
            <el-dialog            
            :visible.sync="dialogVisible"
            width="1200px"
            top="0px"
            :show-close="false"
            :close-on-click-modal="false"
            center
          >
               <div slot="title" style="font-size: 22px;font-weight: bold;">
                 应聘须知
               </div>
                <div class="applyKnow">
                    <ApplyKnow :pJobId="jobId"></ApplyKnow>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button :disabled="seconds>0" style="background-color: #c40001;border-color: #c40001;" type="primary" @click="dialogVisible = false">我已阅读{{ seconds }}s</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>
<script>
 import ApplyKnow from './ApplyKnow.vue';
 export default {
    components: { ApplyKnow },
     name: 'Job',
     data () {
         return {
            majorListSelectValue:'',    
            mainListSelectValue:'',       
            jobPublishList:[],  
            minHeight:'100%',
            loading:true,
            keywords:'',
            oldJobPublishList:[],
            mainList:[],
            majorList:[],
            jobId:'',
            company_desc:'  西安美术学院建校于1949年，其前身为西北人民艺术学院二分部，1949年7月由山西临汾迁至西安市长安县，更名为西北军政大学艺术学院，后历经西北艺术专科学校、西北美术专科学校等阶段，于1960年5月正式定名为西安美术学院，1994年学院整体迁至西安市雁塔区含光路南段。 西安美术学院自建校以来，广纳贤才、汇聚名师，立足卓绝的延安精神和厚重的历史文化传统，传承红色基因，形成了独具特色的艺术教育理念，为国家的建设发展培养了大批优秀艺术人才，创作了许多在中国当代美术史上具有深远影响的作品，为繁荣社会主义艺术事业做出了重要贡献，产生了良好的社会声誉和影响。改革开放以来，西安美术学院以育人为根本、以教学为中心、以教师为主体、以质量为生命、以繁荣文化为己任、秉承“艰苦创业，追求卓越”的精神，恪守“弘美厚德，借古开今”的校训，发挥地域优势，突出西部特色，率先将书法和民间美术纳入课堂教学，长期坚持并重视周秦汉唐历史文化、延安革命文艺、西北民族民间艺术、当代“长安画派”与“黄土画派”四大传统和绘画、书法、美术史论、中国民间美术“四大基础”教学，逐渐形成了基础雄厚、结构合理、特色鲜明的美术教育体系。',
            //dialog相关
            dialogVisible:false,
            seconds:10,
            timer:null,
            haveDialogIds:[],//已经阅读过的招聘信息id
         }
     },
     methods:{
        search(){
            var that=this;
            var mainSelect = this.mainListSelectValue[this.mainListSelectValue.length-1];
            var majorSelect = this.majorListSelectValue;
            var jobTitle=this.keywords;
            console.log('mainSelect:'+mainSelect);
            console.log('majorSelect:'+majorSelect);
            if ((mainSelect == undefined || mainSelect.length==0 || mainSelect=='S') && majorSelect.length==0 && jobTitle.length==0){
                this.jobPublishList=this.oldJobPublishList;
                return;
            }
            var that = this;
            this.loading=true;
            this.$axios.get(this.Global.globalUrl+'/interface/getJobpublishSearch.ashx'
            ,{params:{
                jobId:this.jobId,
                deptId:mainSelect,
                majorId:majorSelect,
                keywords:jobTitle,
            }}
            ).then((res) => {
                
                that.jobPublishList=res.data.jobPublishList;                      
            })
            .catch(() => {
            })
            .finally(()=>{
                setTimeout(() => {
                    that.loading=false;
                }, 1000);                

            })
            
        },
        goJobDetail:function(id){
            this.$router.push({name:'JobDetail',query:{id:id}});

        },
        getDataList:function(publishId){
            var pubId='';
            if (publishId != undefined && publishId.length>0){
                pubId=publishId;
            }
            var that = this;
            this.$axios.get(this.Global.globalUrl+'/interface/getJobpublishList.ashx'
                ,{params:{
                    jobId:this.jobId,
                    publishId:pubId
                }}
                ).then((res) => {
                  
                    that.jobPublishList=res.data.jobPublishList;                      
                    that.oldJobPublishList=res.data.jobPublishList;  
                    that.mainList=res.data.mainList;
                    that.majorList=res.data.majorList;
                })
                .catch(() => {
                })
                .finally(()=>{
                    this.loading=false;
                })

        },
        goJobEdit:function(publishId){
            var that=this;
            console.log(publishId);
            if (this.getSessionStorage('id')==null){
                this.$router.push({name:'Login'});
            }else{
                //弹出dialog层
                if (this.haveDialogIds.indexOf(publishId) === -1){
                    this.dialogVisible=true;
                    this.seconds=10;
                    this.haveDialogIds.push(publishId);
                    //定时器
                    this.timer = setInterval(() => {
                    //需要定时执行的代码
                        if (this.seconds==0){
                            clearTimeout(this.timer)
                            this.timer=null;
                            return;
                        }
                        this.seconds=this.seconds-1;
                    }, 1000);
                    return;
                }

                //根据岗位进行简历必填项的验证
                that.loading=true;
                this.$axios.get(
                    this.Global.globalUrl+'/interface/checkApply.ashx',
                    {params:{
                    jobId:this.jobId,
                    uid:this.getSessionStorage('id')
                }})
                .then((res) => {                    
                   
                    if (res.data.err==0){
                        //保存申请信息
                        var arr = [];
                        var jsont = { "id": that.getSessionStorage('id'), "publishId": publishId,'jobId':that.jobId};
                        arr.push(jsont);

                        this.$axios.post(
                            that.Global.globalUrl+'/interface/saveApply.ashx',
                            JSON.stringify(arr),
                            {
                                header: { 'content-type': 'application/x-www-form-urlencoded' }
                            })
                        .then((res) => {
                            that.loading=false;
                            if (res.data.err==0){
                                this.setLocalStorage('jobId',this.jobId);
                                
                                this.$message({                                 
                                    duration:3000,
                                    type: 'success',
                                    message: '申请成功,可前往【个人中心-已投岗位】查看!'
                                });
                            }else{
                                this.$message({                                   
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        })
                        .catch(() => {
                        })
                        .finally(()=>{                            
                            setTimeout(() => {
                                that.loading=false;
                            }, 1000);
                        })
                    }else{
                        that.loading=false;
                        this.setLocalStorage('jobId',this.jobId);
                        this.$confirm('请前往【个人中心】按照必填项完善您的简历信息！', '提示', {
                        confirmButtonText: '前往个人中心',
                        cancelButtonText: '取消申请',
                        type: 'warning',
                        center: true, //文字居中显示
                        showCancelButton: true, //不显示取消按钮
                        showClose: true, //是否显示右上角的x
                        closeOnClickModal: true, //是否可以点击空白处关闭弹窗
                        }).then(() => {
                            //前往个人中心
                            this.$router.push({name:'JobEdit',query:{jobId:that.jobId}});
                        }).catch(() => {
                        });
                    }
                })
                .catch(() => {
                })
                .finally(()=>{
                    that.loading=false;
                })



            }
        },

     },
     mounted() {   
        //var screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        this.$nextTick(function () {
            this.minHeight = (document.documentElement.clientHeight -200)+'px';
        })

        this.$router.onReady(() => {
            
            if(this.$route.query.jobId != undefined && this.$route.query.jobId != null){
                this.jobId=this.$route.query.jobId;                
                console.log(this.$route.query.jobId);
                this.getDataList(this.$route.query.publishId);

            }
        })
     },
     watch:{
	    //监听到路由（参数）改变
        '$route'(val, from) {
            this.jobId=val.query.jobId;
            // 拿到目标参数 val.query.id 去请求接口
            this.getDataList()
        }
    }


 }
</script>
<style scoped>
/* 重置对话框标题字体颜色 */
.el-dialog__title {
    font-size: 22px !important;
    font-weight: bold !important;
}
</style>